import { format, toZonedTime } from 'date-fns-tz';

function getStrValue(value: unknown): string {
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return value.toString();
  return '';
}

export function percentFormat(value: unknown): string {
  const strValue = getStrValue(value);
  if (strValue === '') return '';
  return strValue + '%';
}

export function utcDateStrToUserZonedDateStrFormat(
  value: unknown,
  userTimeZone: string,
  formatPattern: string,
): string {
  const strValue = getStrValue(value);
  if (strValue === '') return '';
  try {
    return format(toZonedTime(new Date(strValue), userTimeZone), formatPattern);
  } catch (err) {
    return '';
  }
}

// https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript/18650828#18650828
export function formatBytes(bytes: number, decimals = 2): string {
  /* eslint-disable-next-line @typescript-eslint/no-unnecessary-type-conversion */
  if (!+bytes) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = [
    'Bytes',
    'KiB',
    'MiB',
    'GiB',
    'TiB',
    'PiB',
    'EiB',
    'ZiB',
    'YiB',
  ];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

// https://mycleverai.com/web-explanations/how-do-i-convert-a-file-array-to-a-filelist
export function convertFileArrayToFileList(fileArray: File[]): FileList {
  const dataTransfer = new DataTransfer();
  fileArray.forEach((file) => {
    dataTransfer.items.add(file);
  });
  return dataTransfer.files;
}
